// 公募基金-金价走势
import isEmpty from '@fund/basic-lib/dist/lib/lang/isEmpty';
// import { numeral } from '@fund/basic-lib/dist/lib/numeral';
import Model, { valueWithArray } from 'ducker-model';

// 金价
const pointProperty = {
  date: String,
  value: String,
  type: String,
};

const pointKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'PERCENTPRICE',
    defaultValue: '',
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'gold-point',
  },
};

const PointModel = new Model(pointProperty, pointKeyFromPropertyName);

// 金价涨幅
const risePointProperty = {
  date: String,
  value: String,
  type: String,
};

const risePointKeyFromPropertyName = {
  date: 'PDATE',
  value: {
    property: 'CHGRT',
    computed: (value) => (isEmpty(value) ? null : parseFloat(value)),
  },
  type: {
    defaultValue: 'gold-rise-point',
  },
};

const RiseModel = new Model(risePointProperty, risePointKeyFromPropertyName);

// Model
const property = {
  pointList: valueWithArray(Object),
  risePointList: valueWithArray(Object),
};

const replacedKeyFromPropertyName = {
  pointList: {
    property: 'data',
    computed: (data) => PointModel.objectArrayWithKeyValuesArray(data),
  },
  risePointList: {
    property: 'data',
    computed: (data) => RiseModel.objectArrayWithKeyValuesArray(data),
  },
};

export default new Model(property, replacedKeyFromPropertyName);
